import WashConfig  from "./WashConfig";

export default WashConfig;